import React from 'react';
import { Link, Typography } from '@one-thd/sui-atomic-components';
var handleButtonClick = function (suspendCartCheck, setIsChangeForm, setIsConfirmation, setIsDeliveryDetails, resetBodfsFlow) {
    if (resetBodfsFlow) {
        resetBodfsFlow();
    }
    setIsChangeForm(true);
    if (setIsConfirmation)
        setIsConfirmation(false);
    if (setIsDeliveryDetails)
        setIsDeliveryDetails(false);
    suspendCartCheck();
};
export var newDeliveryAddress = function (newDeliveryAddressDetails, suspendCartCheck, setIsChangeForm, setIsConfirmation, setIsDeliveryDetails, resetBodfsFlow) { return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
    React.createElement("div", { className: "sui-flex sui-flex-col" },
        React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between" },
            React.createElement(Typography, { weight: "bold" },
                newDeliveryAddressDetails.firstName,
                ' ',
                newDeliveryAddressDetails.lastName),
            React.createElement(Link, { component: "button", onClick: function () {
                    return handleButtonClick(suspendCartCheck, setIsChangeForm, setIsConfirmation, setIsDeliveryDetails, resetBodfsFlow);
                } }, "Edit")),
        React.createElement(Typography, null, newDeliveryAddressDetails.addressLine1),
        React.createElement(Typography, null, newDeliveryAddressDetails.addressLine2),
        React.createElement(Typography, null,
            [newDeliveryAddressDetails.city, newDeliveryAddressDetails.state]
                .filter(function (item) { return item === null || item === void 0 ? void 0 : item.trim(); })
                .join(', '),
            ' ',
            newDeliveryAddressDetails.zipCode),
        React.createElement(Link, { href: 'tel:' + newDeliveryAddressDetails.phoneNumber, target: "_parent", underline: "hover" }, newDeliveryAddressDetails.phoneNumber)))); };
